import { PaginationListRequest } from "@shared/e-invoice";

export class ListBebopOperationsImportHistoryRequest extends PaginationListRequest {
    CompanySiret: string;
    CompanyId: number;
    StartDate: string | null;
    EndDate: string | null;
}